import Vue from 'vue'
import Router from 'vue-router'


import Login from '../views/apps/Login/Login.vue'
import Dashboard from '../views/apps/Dashboard/Dashboard.vue';

// User Administration
import AddUser from '../views/apps/Users/AddUser/AddUser.vue';
import UserList from '../views/apps/Users/UserList/UserList.vue';
import UserChangePassword from '../views/apps/Users/UserChangePassword/UserChangePassword.vue';

// Image Administration
import ImageAdmin from '../views/apps/ImageAdmin/ImageAdmin.vue';

// reports
import MissingImageReport from '../views/apps/Reports/MissingImageReport/MissingImageReport.vue';

// marketing materials
import MarketingMaterialUpload from "../views/apps/MarketingMaterials/MarketingMaterialUpload/MarketingMaterialUpload.vue";
import MarketingMaterialList from "../views/apps/MarketingMaterials/MarketingMaterialList/MarketingMaterialList.vue";

// do not sell list
import DoNotSellList from "@/views/apps/DoNotSellList/DoNotSellList.vue";

// aces upload
import AcesUpload from "@/views/apps/AcesUpload/AcesUpload.vue";

// common
import ForgotPassword from '../views/pages/authentication/ForgotPassword.vue'
import NotFound from '../views/pages/NotFound.vue'


//ui
import layouts from '../layout'
import store from '../store'



Vue.use(Router);

let layout = layouts.navLeft;
const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			alias: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			meta: {
				auth: true,
				layout: layout,

			}
		},
        {
            path: '/users/new',
            alias: '/add-user',
            name: 'add-user',
            component: AddUser,
            meta: {
                auth: true,
                layout: layout,
            }
        },
        {
            path: '/users/change-password',
            alias: '/user-change-password',
            name: 'user-change-password',
            component: UserChangePassword,
            meta: {
                auth: true,
                layout: layout,
            }
        },
		{
			path: '/users/list',
			alias: '/users-list',
			name: 'user-list',
			component: UserList,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/mgt/images/:partNumber?',
			alias: '/mgt-images',
			name: 'mgt-images',
			component: ImageAdmin,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/reports/missing-images',
			alias: '/reports/missing-images',
			name: 'reports-missing-images',
			component: MissingImageReport,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/marketing-materials/upload',
			alias: '/marketing-materials/upload',
			name: 'marketing-materials-upload',
			component: MarketingMaterialUpload,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/marketing-materials/list',
			alias: '/marketing-materials/list',
			name: 'marketing-materials-list',
			component: MarketingMaterialList,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/do-not-sell',
			alias: '/do-not-sell',
			name: 'do-not-sell',
			component: DoNotSellList,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/aces-upload',
			alias: '/aces-upload',
			name: 'aces-upload',
			component: AcesUpload,
			meta: {
				auth: true,
				layout: layout,
			}
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/forgot-password',
			name: 'forgot-password',
			component: ForgotPassword,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{ 
			path: '/logout',
			beforeEnter (to, from, next) {
				auth.logout();
				next({path:'/login'})
			}
		},
		{
			path: '*',
			name: 'not-found',
			component: NotFound,
			meta: {
				layout: layouts.contenOnly
			}
		}
	]
});


const l = {
	contenOnly(){
		store.commit('setLayout', layouts.contenOnly)
	},
	navLeft(){
		store.commit('setLayout', layouts.navLeft)
	},
	navRight(){
		store.commit('setLayout', layouts.navRight)
	},
	navTop(){
		store.commit('setLayout', layouts.navTop)
	},
	navBottom(){
		store.commit('setLayout', layouts.navBottom)
	},
	set(layout){
		store.commit('setLayout', layout)
	}
};

//insert here login logic
const auth = {
	loggedIn() {
		return store.getters.isLogged
	},
	logout() {
		store.commit('setLogout')
	}
};

router.beforeEach((to, from, next) => {
	let authrequired = true;

	if(to && to.meta && to.meta.auth) {
		authrequired = true
	}

	
	if(authrequired) {
		if(auth.loggedIn()) {
			if(to.name === 'login') {
				window.location.href = '/';
				return false
			} else { 
				next()
			}
		} else {
			if(to.name !== 'login'){
				window.location.href = '/login';
				return false
			}
			next()
		}
	} else {
		if(auth.loggedIn() && to.name === 'login'){
			window.location.href = '/';
			return false
		} else {
			next()
		}
	}

	if(to && to.meta && to.meta.layout){
		l.set(to.meta.layout)
	}	
});

router.afterEach((to, from) => {
	setTimeout(()=>{
		store.commit('setSplashScreen', false)
	}, 500)
});

export default router